"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormElementWrapper = _interopRequireDefault(require("./FormElementWrapper"));

var _excluded = ["label", "input", "meta", "liveSaver", "tooltip"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CheckBox = function CheckBox(props) {
  var label = props.label,
      input = props.input,
      meta = props.meta,
      liveSaver = props.liveSaver,
      tooltip = props.tooltip,
      rest = _objectWithoutProperties(props, _excluded);

  var handleCheck = function handleCheck(e) {
    input.onChange && input.onChange(e);
  };

  return /*#__PURE__*/_react["default"].createElement(_FormElementWrapper["default"], _extends({}, rest, {
    tooltip: tooltip,
    meta: meta,
    label: label,
    liveSaver: liveSaver
  }), /*#__PURE__*/_react["default"].createElement("label", {
    className: "container-checkbox"
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({
    checked: Boolean(input ? input.value : props.value)
  }, input, rest, {
    type: "checkbox",
    onChange: handleCheck
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "checkmark"
  })));
};

CheckBox.displayName = 'CheckBox';
CheckBox.propTypes = {
  label: _propTypes["default"].any
};
CheckBox.defaultProps = {
  label: ''
};
var _default = CheckBox;
exports["default"] = _default;